"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'hotspotCutout',
  props: {
    datas: Object
  },
  data: function data() {
    return {
      resPath: process.env.VUE_APP_IMAGE_PATH || ''
    };
  },
  computed: {
    hoverShadow: function hoverShadow() {
      return this.datas.imgStyle === 'shadow' ? '0 4px 12px rgba(0, 0, 0, 0.15)' : 'none';
    },
    // 图片样式（圆角、边距、投影、自定义宽高）
    imgStyleObj: function imgStyleObj() {
      var style = {
        borderRadius: (this.datas.borderRadius || 0) + 'px',
        paddingLeft: (this.datas.pagePadding || 0) + 'px',
        paddingRight: (this.datas.pagePadding || 0) + 'px',
        boxSizing: 'border-box',
        boxShadow: this.datas.imgStyle === 1 ? '0 2px 8px rgba(0, 0, 0, 0.1)' : 'none'
      };
      if (this.datas.imgWidth) {
        style.width = this.datas.imgWidth + 'px';
        style.maxWidth = 'none';
      }
      if (this.datas.imgHeight) {
        style.height = this.datas.imgHeight + 'px';
        style.maxHeight = 'none';
      }
      return style;
    }
  }
};